export enum BehalfOfRelation {
  Broker = "Broker",
  CaregiverGuardian = "CaregiverGuardian"
}